// frontend/src/Components/NavLink/navlink-component.js
import React from 'react';
import { useSelector } from 'react-redux';
import useHandleRedirect from '../../Hooks/useHandleRedirect';

/**
 * NavLink Component
 * Clean, high-performance link component that delegates 
 * navigation logic to useHandleRedirect.
 */
export default function NavLink({
    href,
    children,
    className = '',
    title = '',
    showUnderline = true,
    target,
    rel,
    ...props
}) {
    const handleRedirect = useHandleRedirect();
    const dir = useSelector((state) => state.systemData?.dir || 'rtl');

    const handleClick = (e) => {
        // Standard UX: Allow default behavior for middle-clicks or modified clicks
        if (e.button !== 0 || e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) return;

        // Prevent hard reload for the <a> tag
        e.preventDefault();
        // The hook handles the rest (Internal vs External vs Protocol)
        handleRedirect(href);
    };

    // SEO fallback for title
    const seoTitle = title || (typeof children === 'string' ? children : '');
    
    // Language-aware animation origin
    const originClass = dir === 'rtl' ? 'origin-right' : 'origin-left';

    return (
        <a
            href={href}
            onClick={handleClick}
            title={seoTitle}
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : rel}
            className={`group relative py-1 inline-block transition-all duration-300 opacity-90 hover:opacity-100 cursor-pointer ${className}`}
            {...props}
        >
            <span className="relative">
                {children}
                {showUnderline && (
                    <span className={`absolute bottom-0 left-0 w-full h-[1px] bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ${originClass}`} />
                )}
            </span>
        </a>
    );
}